"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _capitalize = _interopRequireDefault(require("../capitalize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultMonthOptions = {
  format: 'MMM',
  locale: 'es',
  capitalize: true
};

/**
 * Retrieves the formatted month component of a given date based on the specified options.
 *
 * @param {Date} date - The date to retrieve the month from.
 * @param {MonthOptions} [options={}] - Options for configuring the month format.
 * @returns {string} - The formatted month string (e.g., "Jun", "December", "8").
 *
 * @example
 * const month1 = getMonth(new Date(), { format: 'MMM', locale: 'en' }) // e.g., "Jun"
 * const month2 = getMonth(new Date(), { format: 'MMMM', locale: 'es' }) // e.g., "Enero"
 * const month3 = getMonth(new Date(), { format: 'M' }) // e.g., "8" for August
 */
function getMonth(date) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    format,
    locale,
    capitalize: shouldCapitalize
  } = _objectSpread(_objectSpread({}, defaultMonthOptions), options);
  let month;
  if (format === 'M') {
    month = (date.getMonth() + 1).toString(); // Get month number
  } else {
    month = date.toLocaleString(locale, {
      month: format === 'MMM' ? 'short' : 'long'
    });
  }
  if (shouldCapitalize && format !== 'M') {
    month = (0, _capitalize.default)(month);
  }
  return month;
}
var _default = exports.default = getMonth;